import { Directive, Input, OnInit, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { MatTooltip } from '@angular/material';
// import { FileLinker } from './file.linker';

@Directive({
    selector: 'input[accept], textarea[accept]',
    host: {
     '(keydown)': 'onKeyDown($event)'
    },
    exportAs: 'acceptInput',
})
/**
 * Directive applicable to inputs and textareas, allowing only specific characters to be entered.
 * <br>
 * Useful for example if only Latin or Arabic characters are allowed, if digits are to be prohibited, etc.
 */
export class InputAcceptDirective implements OnInit {

     /**
      * What to allow as input (object of type AcceptKeys or string including any of the following):
      * <ul>
      * <li>en = allow english alphabet characters</li>
      * <li>ar = allow Arabic alphabet characters</li>
      * <li>digit = allow Numeric characters</li>
      * </ul>
      */
     @Input('accept')
     accept: string | AcceptKeys;

     // @ViewChild('acceptTooltip', {static: true, read: MatTooltip})
     // tooltip: MatTooltip;

     constructor(private el: ElementRef) {}

     ngOnInit() {
          this.getRestrictions();
     }

     ngOnChanges(changes: SimpleChanges) {
          this.getRestrictions();
     }

     getRestrictions() {
          if (this.accept === '' + this.accept) {
               if (this.accept == '' || this.accept == '*' || this.accept == '{') {
                    this.accept = {
                         en: true,
                         ar: true,
                         digit: true,
                    }
               }
               else {
                    // string needs to be a json object..
                    this.accept = {
                         en: (<string> this.accept).includes('en'),
                         ar: (<string> this.accept).includes('ar'),
                         digit: (<string> this.accept).includes('digit'),
                    }
               }
          }
          // console.log('Input limited to ', this.accept);
     }

     showTooltip() {
          // if (this.el.nativeElement['matTooltip']) {
          //      this.el.nativeElement['matTooltip'].show();
          // }
     }

    onKeyDown(event: any) {
         // console.log("Keydown", event);
          if (!event.key) return;
     
          let code = +event.key.charCodeAt(0);
          let allow = this.accept as AcceptKeys;

          if (event.keyCode > 20 && this.accept) {
               if (!allow.en) 
               if (code >= 0x20 && code < 0x024F) {
                    // 80 is the basic characters.. the rest are extended..

                         this.showTooltip();
                         //if (this.tooltip) this.tooltip.show();
                         // console.log("Keydown prevented - not English");
                    event.preventDefault();
               }
               if (!allow.ar) 
               if ((code >= 0x600 && code <= 0x06FF) ||
                    (code >= 0x750 && code <= 0x77F) || 
                    (code >= 0xFB50 && code <= 0xFDFF) ||
                    (code >= 0xFE70 && code <= 0xFEFF) ||
                    (event.keyCode == 66 && event.key != 'b' && event.key != 'B')) {
                         // the last one is a special case.. but not working !!!

                         this.showTooltip();
                         // if (this.tooltip) this.tooltip.show();
                         // console.log("Keydown prevented - not Arabic");
                    event.preventDefault();
               }
               if (!allow.digit) 
               if (event.key === +(event.key) || event.code.includes('Digit')) {

                         this.showTooltip();
                         // if (this.tooltip) this.tooltip.show();
                         // console.log("Keydown prevented - not a digit");
                    event.preventDefault();
               }
          }
    }

}

export interface AcceptKeys {
     en: boolean,
     ar: boolean,
     digit: boolean
}